import { Model } from 'miragejs';

// Mirage-only Model
// Helps simulate the ActiveStorage / Direct Upload endpoints.
// This model is server-side / payload only.
// It is not consumed by Ember Data.

export default Model.extend({
  blob: null,
});
